import { FoodsTags, Typography } from "@foodpilot/foods";
import { Stack, Theme, useTheme } from "@mui/material";
import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

export const currentActionMarkerSx = (theme: Theme) => ({
    boxShadow: `inset ${theme.spacing(0.5)} 0 0 ${theme.palette.primary[700]}`,
});

type Props = {
    title: string;
    isCurrentAction: boolean;
    showCurrentActionTag: boolean;
    otherActionVariant: ComponentProps<typeof Typography>["variant"];
};

export const EngagedActionTitle = (props: Props) => {
    const { title, isCurrentAction, showCurrentActionTag, otherActionVariant } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Stack gap={theme.spacing(0.5)} alignItems={"flex-start"}>
            <Typography variant={isCurrentAction ? "body-bold" : otherActionVariant}>{title}</Typography>
            {isCurrentAction && showCurrentActionTag && (
                <FoodsTags
                    variant="tags-brand"
                    label={t("action_plan.action.this_action", "This action")}
                    disabled={true}
                />
            )}
        </Stack>
    );
};
